import { render, staticRenderFns } from "./forms-index.vue?vue&type=template&id=5a4f6a3a&"
import script from "./forms-index.vue?vue&type=script&lang=js&"
export * from "./forms-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports